"use strict";
var UserSessionService = (function () {
    /* @ngInject */
    function UserSessionService() {
        //nothing yet
    }
    UserSessionService.prototype.setDistrictMode = function (tenantId, district) {
        if (district) {
            sessionStorage.setItem(UserSessionService.storageKeys.districtMode, "Y");
            sessionStorage.setItem(UserSessionService.storageKeys.districtTenantId, tenantId);
        }
        else {
            sessionStorage.removeItem(UserSessionService.storageKeys.districtMode);
            sessionStorage.removeItem(UserSessionService.storageKeys.districtTenantId);
            sessionStorage.removeItem(UserSessionService.storageKeys.currentSchool);
        }
    };
    UserSessionService.prototype.isDistrictMode = function () {
        return sessionStorage.getItem(UserSessionService.storageKeys.districtMode) != null;
    };
    UserSessionService.prototype.getDistrictTenantId = function () {
        return sessionStorage.getItem(UserSessionService.storageKeys.districtTenantId);
    };
    UserSessionService.prototype.setCurrentSchool = function (institution) {
        if (!institution) {
            sessionStorage.removeItem(UserSessionService.storageKeys.currentSchool);
        }
        else {
            sessionStorage.setItem(UserSessionService.storageKeys.currentSchool, JSON.stringify(institution));
        }
    };
    UserSessionService.prototype.hasCurrentSchool = function () {
        return sessionStorage.getItem(UserSessionService.storageKeys.currentSchool) != null;
    };
    UserSessionService.prototype.getCurrentSchool = function () {
        var curentSchool = sessionStorage.getItem(UserSessionService.storageKeys.currentSchool);
        if (curentSchool != null) {
            return JSON.parse(curentSchool);
        }
        else {
            return null;
        }
    };
    UserSessionService.prototype.setTenantManagingDefaults = function (value) {
        sessionStorage.removeItem(UserSessionService.storageKeys.tenantManagingDefaults);
        if (value) {
            sessionStorage.setItem(UserSessionService.storageKeys.tenantManagingDefaults, "Y");
        }
    };
    UserSessionService.prototype.isTenantManagingDefaults = function () {
        return !!sessionStorage.getItem(UserSessionService.storageKeys.tenantManagingDefaults);
    };
    UserSessionService.prototype.setSubscriptionStudyPrograms = function (subscriptionStudyPrograms) {
        sessionStorage.setItem(UserSessionService.storageKeys.subscriptionStudyPrograms, JSON.stringify(subscriptionStudyPrograms));
    };
    UserSessionService.prototype.getSubscriptionStudyPrograms = function () {
        var subscriptionStudyPrograms = sessionStorage.getItem(UserSessionService.storageKeys.subscriptionStudyPrograms);
        if (subscriptionStudyPrograms != null) {
            return JSON.parse(subscriptionStudyPrograms);
        }
        return null;
    };
    UserSessionService.prototype.setHideWelcomeModal = function () {
        sessionStorage.setItem(UserSessionService.storageKeys.welcomeModal, "hide");
    };
    UserSessionService.prototype.showWelcomeModal = function () {
        return !sessionStorage.getItem(UserSessionService.storageKeys.welcomeModal);
    };
    UserSessionService.prototype.setNavigationMenu = function (navigationMenu) {
        sessionStorage.setItem(UserSessionService.storageKeys.navigationMenu, JSON.stringify(navigationMenu));
    };
    UserSessionService.prototype.getNavigationMenu = function () {
        var currentMenu = sessionStorage.getItem(UserSessionService.storageKeys.navigationMenu);
        if (currentMenu != null) {
            return JSON.parse(currentMenu);
        }
        else {
            return null;
        }
    };
    UserSessionService.prototype.setLayoutUser = function (layoutUser) {
        sessionStorage.setItem(UserSessionService.storageKeys.layoutUser, JSON.stringify(layoutUser));
    };
    UserSessionService.prototype.getLayoutUser = function () {
        var layoutUser = sessionStorage.getItem(UserSessionService.storageKeys.layoutUser);
        if (layoutUser != null) {
            return JSON.parse(layoutUser);
        }
        else {
            return null;
        }
    };
    UserSessionService.storageKeys = {
        districtMode: "testprep.districtmode",
        districtTenantId: "testprep.districtid",
        currentSchool: "testprep.school",
        subscriptionStudyPrograms: "testprep.subscriptionStudyPrograms",
        tenantManagingDefaults: "testprep.tenantManagingDefaults",
        welcomeModal: "testprep.welcomeModal",
        navigationMenu: "testprep.navigationMenu",
        layoutUser: "testprep.layoutUser"
    };
    return UserSessionService;
}());
exports.UserSessionService = UserSessionService;



/** WEBPACK FOOTER **
 ** ./app/common/user-session/user-session.service.ts
 **/